import PropTypes from 'prop-types';
import { useMemo } from 'react';

// material-ui
import { AppBar, Toolbar, useTheme } from '@mui/material';

// project import
import HeaderContent from './HeaderContent';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = ({ open, handleDrawerToggle }) => {
  const theme = useTheme();
  // header content
  const headerContent = useMemo(() => <HeaderContent handleDrawerToggle={handleDrawerToggle} />, [handleDrawerToggle]);

  // common header
  const mainHeader = <Toolbar sx={{ width: '100%' }}>{headerContent}</Toolbar>;

  // app-bar params
  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      zIndex: 1198,
      width: open ? { xs: '100%', lg: 'calc(100% - 356px)' } : { xs: '100%', lg: 'calc(100% - 156px)' },
      marginTop: { xs: 0, lg: '32px' },
      marginRight: { xs: 0, lg: '32px' },
      borderRadius: { xs: 0, lg: '24px' },
      boxShadow: { xs: 'none', lg: '0px 0px 16px 0px #00000014' },
      py: { xs: 1, lg: 0 },
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: open ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen
      })
    }
  };

  return <AppBar {...appBar}>{mainHeader}</AppBar>;
};

Header.propTypes = {
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func
};

export default Header;
